import { render } from "./TwinDoubleMarkersResultFileEdit.vue?vue&type=template&id=152310a0&scoped=true"
import script from "./TwinDoubleMarkersResultFileEdit.vue?vue&type=script&lang=js"
export * from "./TwinDoubleMarkersResultFileEdit.vue?vue&type=script&lang=js"

import "./TwinDoubleMarkersResultFileEdit.vue?vue&type=style&index=0&id=152310a0&lang=scss&scoped=true"
import "./TwinDoubleMarkersResultFileEdit.vue?vue&type=style&index=1&id=152310a0&lang=scss"
import "./TwinDoubleMarkersResultFileEdit.vue?vue&type=style&index=2&id=152310a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152310a0"]])

export default __exports__